import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/about/codeofconductbanner.webp";
import { Link } from "react-router-dom";
import procedureImg from "../../Images/gov-body/meeting.webp"; // adjust if needed

const CodeOfConduct = () => {
  return (
    <>
      <title>ISBM University Code of Conduct | Transparency Matters</title>
      <meta
        name="description"
        content="Explore ISBM University's Code of Conduct and Right to Information (RTI) guidelines. Learn about our commitment to transparency and ethical standards."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Code of Conduct at ISBM University</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Code of Conduct
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="mb-5">
            <Col lg={12}>
              <div className="section-intro">
                <p >
                  ISBM University is committed to nurturing a culture of
                  integrity, discipline, and mutual respect across all levels of
                  its academic and administrative structure. Our Code of Conduct
                  serves as a guiding framework to uphold ethical behavior,
                  professionalism, and accountability. Every member of the
                  university community, including faculty, students, management,
                  and hostel authorities, is expected to adhere to these
                  standards to maintain a safe, inclusive, and empowering
                  learning environment.
                </p>
                <p >
                  The Code of Conduct for Faculty promotes academic integrity,
                  fair assessment, and mentorship, while the Management Code
                  ensures responsible governance, transparent decision-making,
                  and respect for institutional values. The Student Code of
                  Conduct focuses on behavior, discipline, and participation in
                  both academic and extracurricular activities, fostering
                  responsible citizenship. Additionally, the Hostel Board Code
                  emphasizes community living, safety, and student welfare in
                  residential facilities, making campus life secure and
                  enriching.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Faculty Code Card */}
            <Col md={6} lg={4} className="p-2">

              <div className="single-procedure h-100 text-center">
                <div className="procedure-image">
                  <img
                    src={procedureImg}
                    alt="application-thumb"
                    className="img-fluid"
                  />
                </div>
                <div className="icon-box rounded-circle bg-light mx-auto my-2 d-flex justify-content-center align-items-center">
                  <i className="ti ti-user-circle fs-1 text-blue"></i>
                </div>
                <h3 className="mb-3 fw-bold text-light">
                  Faculty
                  <br /> Code of Conduct
                </h3>
                <Link to="/code-of-conduct-faculty" className="btn btn-sm btn-outline-light">
                  View Details <i className="ti ti-arrow-right ms-2"></i>
                </Link>
              </div>
            </Col>

            {/* Student Code Card */}
            <Col md={6} lg={4} className="p-2">


              <div className="single-procedure h-100 text-center">
                <div className="procedure-image">
                  <img
                    src={procedureImg}
                    alt="application-thumb"
                    className="img-fluid"
                  />
                </div>
                <div className="icon-box rounded-circle bg-light mx-auto my-2 d-flex justify-content-center align-items-center">
                  <i className="ti ti-school fs-1 text-blue"></i>
                </div>
                <h3 className="mb-3 fw-bold text-light">
                  Student
                  <br /> Code of Conduct
                </h3>

                <Link to="/code-of-conduct-student" className="btn btn-sm btn-outline-light">
                  View Details <i className="ti ti-arrow-right ms-2"></i>
                </Link>
              </div>
            </Col>

            {/* Management Code Card */}
            <Col md={6} lg={4} className="p-2">

              <div className="single-procedure h-100 text-center">
                <div className="procedure-image">
                  <img
                    src={procedureImg}
                    alt="application-thumb"
                    className="img-fluid"
                  />
                </div>
                <div className="icon-box rounded-circle bg-light mx-auto my-2 d-flex justify-content-center align-items-center">
                  <i className="ti ti-building fs-1 text-blue"></i>
                </div>
                <h3 className="mb-3 fw-bold text-light">
                  Management
                  <br /> Code of Conduct
                </h3>

                <Link to="/code-of-conduct-management" className="btn btn-sm btn-outline-light">
                  View Details <i className="ti ti-arrow-right ms-2"></i>
                </Link>
              </div>
            </Col>

            {/* Hostel Code Card */}
            <Col md={6} lg={4} className="">


              <div className="single-procedure h-100 text-center">
                <div className="procedure-image">
                  <img
                    src={procedureImg}
                    alt="application-thumb"
                    className="img-fluid"
                  />
                </div>
                <div className="icon-box rounded-circle bg-light mx-auto my-2 d-flex justify-content-center align-items-center">
                  <i className="ti ti-home fs-1 text-blue"></i>
                </div>
                <h3 className="mb-3 fw-bold text-light">
                  Hostel Board <br />
                  Code of Conduct
                </h3>

                <Link to="/code-of-conduct-boardes-of-hostel" className="btn btn-sm btn-outline-light">
                  View Details <i className="ti ti-arrow-right ms-2"></i>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CodeOfConduct;
